import { render, staticRenderFns } from "./mainContainer.vue?vue&type=template&id=25872a54&scoped=true&"
import script from "./mainContainer.vue?vue&type=script&lang=js&"
export * from "./mainContainer.vue?vue&type=script&lang=js&"
import style0 from "./mainContainer.vue?vue&type=style&index=0&id=25872a54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25872a54",
  null
  
)

export default component.exports